<template>
	<div class="gallery-wrapper" :class="[isMultiblock == 'false' ? 'container-lg' : '']">
		<div class="row">
			<div class="col-md-12">
				<h2 v-if="pictureData.config.title">{{ pictureData.config.title }}</h2>
			</div>
		</div>
		<div class="row">
			<div class="col-12 wrapper-carousel-fullscreen-button">
				<button type="button" class="carousel-fullscreen-button" data-bs-toggle="modal"
					:data-bs-target="['#galleryModal-' + pictureKey]">
					<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M13.8995 4.10052V2.10052H21.8995V10.1005H19.8995V5.51477L14.1213 11.293L12.7071 9.87878L18.4854 4.10052H13.8995Z"
							fill="currentColor" />
						<path
							d="M4.10046 13.8995H2.10046V21.8995H10.1005V19.8995H5.51468L11.2929 14.1212L9.87872 12.707L4.10046 18.4853V13.8995Z"
							fill="currentColor" />
					</svg>
				</button>
			</div>
			<template
				v-if="pictureData.config.pictures != '' && pictureData.config.viewType != 'singlePicture' && pictureData.config.pictures.length > 1 && pictureData.type != 'layout'">
				<div class="gallery">
					<!-- Full Slider Gallery -->
					<Splide @splide:move="syncThumbToMain" ref="main"
						:options="fullGalleryOptions"
						:class="[pictureData.config.viewType == 'singlePicture' ? 'single-picture' : '']">
						<SplideSlide v-for="(picture, index) in pictureData.config.pictures" :key="index">
							<img :src="`${picture.url}`" :alt="`${picture.caption}`">
							<div class="carousel-caption d-none d-md-block">
								<span v-if="picture.caption">{{ picture.caption }}</span>
							</div>
						</SplideSlide>
					</Splide>
				</div>
			</template>
			<template
				v-if="pictureData.config.pictures != '' && pictureData.config.viewType == 'singlePicture' || pictureData.config.viewType == 'slideShow' && pictureData.config.pictures.length == 1">
				<div class="gallery gallery-single">
					<!-- Gallery Single Picture -->
					<Splide @splide:move="syncThumbToMain" ref="main"
						:options="{ type: 'loop', width: '100%', heightRatio: 0.5625, pagination: false, lazyLoad: 'nearby', arrows: false }"
						:class="[pictureData.config.viewType == 'singlePicture' ? 'single-picture' : '']">
						<SplideSlide v-for="(picture, index) in pictureData.config.pictures" :key="index">
							<img :src="`${picture.url}`" :alt="`${picture.caption}`">
							<div class="carousel-caption d-none d-md-block">
								<span v-if="picture.caption">{{ picture.caption }}</span>
							</div>
						</SplideSlide>
					</Splide>
				</div>
			</template>
			<template v-if="pictureData.type == 'layout'">
				<div class="gallery-layout">
					<!-- Layout Slider -->
					<Splide ref="main" :options="layoutOptions"
						:class="[pictureData.config.viewType == 'singlePicture' ? 'single-picture' : '']">
						<SplideSlide v-for="(picture, index) in pictureData.config.pictures" :key="index">
							<img :src="`${picture.url}`" :alt="`${picture.caption}`">
							<div class="carousel-caption d-none d-md-block">
								<span v-if="picture.caption">{{ picture.caption }}</span>
							</div>
						</SplideSlide>
					</Splide>
				</div>
			</template>
			<template
				v-if="pictureData.config.pictures != '' && pictureData.config.viewType != 'singlePicture' && pictureData.config.pictures.length > 1 && pictureData.type != 'layout'">
				<!-- Thumbnail Slider -->
				<div class="gallery-thumbnails">
					<Splide @splide:move="syncMainToThumb" ref="thumbs"
						:options="{ type: 'slide', rewind: true, gap: 1, pagination: false, fixedWidth: 110, fixedHeight: 70, cover: true, focus: 'center', isNavigation: true, updateOnMove: true, arrows: false }"
						:class="[pictureData.config.viewType == 'singlePicture' ? 'single-picture' : '',]">
						<SplideSlide v-for="(thumbs, index) in pictureData.config.pictures" :key="index">
							<img :src="`${thumbs.url}`" :alt="`${thumbs.caption}`" />
						</SplideSlide>
					</Splide>
				</div>
			</template>
			<!-- Modal -->
			<div class="gallery gallery-modal">
				<div class="modal" :id="['galleryModal-' + pictureKey]" tabindex="-1"
					:aria-labelledby="['galleryModal-' + pictureKey] + 'Label'" aria-hidden="true">
					<div class="modal-dialog">
						<div class="modal-content">
							<div class="modal-body">
								<button type="button" class="carousel-fullscreen-button" data-bs-dismiss="modal" aria-label="close">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
										stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
										class="feather feather-minimize-2">
										<polyline points="4 14 10 14 10 20"></polyline>
										<polyline points="20 10 14 10 14 4"></polyline>
										<line x1="14" y1="10" x2="21" y2="3"></line>
										<line x1="3" y1="21" x2="10" y2="14"></line>
									</svg>
								</button>
								<Splide
									:options="{ rewind: true, width: '100%', heightRatio: 0.5625, lazyLoad: 'nearby', arrows: 'slider', arrowPath: 'M15.0378 6.34317L13.6269 7.76069L16.8972 11.0157L3.29211 11.0293L3.29413 13.0293L16.8619 13.0157L13.6467 16.2459L15.0643 17.6568L20.7079 11.9868L15.0378 6.34317Z' }"
									:class="[pictureData.config.viewType == 'singlePicture' ? 'single-picture' : '']">
									<SplideSlide v-for="(picture, index) in pictureData.config.pictures" :key="index">
										<img :src="`${picture.url}`" :alt="`${picture.caption}`">
										<div class="carousel-caption d-none d-md-block">
											<span v-if="picture.caption">{{ picture.caption }}</span>
										</div>
									</SplideSlide>
								</Splide>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/splide.min.css';

export default {
	components: {
		Splide,
		SplideSlide
	},

	data() {
		return {
			fullGalleryOptions: {
				type: 'loop', 
				pagination: 'false', 
				width: '100%', 
				heightRatio: 0.5625, 
				lazyLoad: 'nearby', 
				arrows: true, 
				arrowPath: 'M15.0378 6.34317L13.6269 7.76069L16.8972 11.0157L3.29211 11.0293L3.29413 13.0293L16.8619 13.0157L13.6467 16.2459L15.0643 17.6568L20.7079 11.9868L15.0378 6.34317Z',
				breakpoints: {
					992: {
						pagination: 'true',
					},
				}

			},
			layoutOptions: {
				rewind: true,
				width: '100%',
				lazyLoad: 'nearby',
				perPage: 3,
				// heightRatio: 0.2,
				height: 'auto',
				gap: '2rem',
				arrows: false,
				pagination: false,
				arrowPath: "M15.0378 6.34317L13.6269 7.76069L16.8972 11.0157L3.29211 11.0293L3.29413 13.0293L16.8619 13.0157L13.6467 16.2459L15.0643 17.6568L20.7079 11.9868L15.0378 6.34317Z",
				breakpoints: {
					992: {
						perPage: 2,
						// heightRatio: 0.3,
						height: 'auto',
						gap: '2rem',
						arrows: true,
					},
					769: {
						perPage: 1,
						height: 'auto',
						gap: 0,
						arrows: true,
					}
				}
			},
		};
	},

	methods: {
		syncMainToThumb(splide, newIndex) {
			const mainSlider = this.$refs.main;
			mainSlider.go(newIndex);
		},

		syncThumbToMain(splide, newIndex) {
			const thumbSlider = this.$refs.thumbs;
			thumbSlider.go(newIndex);

		}
	},

	props: {
		pictureData: {
			type: Object,
		},
		pictureKey: {
			type: Number
		},
		index: {
			type: Number
		},
		isMultiblock: {
			type: String
		}
	},

	mounted() {
	}
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/design-turin/galleryItemComponent.scss";
</style>